@if (package$ | async; as pkg) {
  <div class="layout-col full">
    <!-- Header Section -->
    <elder-toolbar>
      <button mat-icon-button *elderToolbarColumn="'left.begin'" (click)="onClose($event)">
        <mat-icon>close</mat-icon>
      </button>
      <elder-header
        *elderToolbarColumn="'left'"
        [header]="('packages.package' | translate) + ' ' + pkg.number"
        [subheader]="'ID: ' + pkg.id"
      >
      </elder-header>

      <div *elderToolbarColumn="'right.actions'">
        <div class="layout-row place-start-center">
          @if (company()) {
            <app-entity-link
              [entityType]="'package'"
              [entityId]="pkg.id"
              [company]="company()"
            ></app-entity-link>
          }

          <button mat-icon-button (click)="onPreviewPackageLabel($event)">
            <mat-icon matTooltip="{{ 'context.preview' | translate }}">print</mat-icon>
          </button>

          <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
      <ng-template elderToolbarColumn="right" [elderToolbarDefault]="true">
        <!-- Clear language switcher -->
      </ng-template>
    </elder-toolbar>
    <!-- Content -->
    <form #mainFrm="ngForm" class="full flex">
      <elder-basic-pane-layout class="full">
        <!-- General -->
        <elder-pane class="flex-40">
          <elder-pane-content>
            <div class="layout-row">
              <!-- Identification -->
              <div class="flex layout-col">
                <elder-pane-subtitle>{{
                  'context.identification' | translate
                }}</elder-pane-subtitle>
                <div class="layout-row gap-md">
                  <mat-form-field>
                    <mat-label>{{ 'orders.work.order' | translate }}</mat-label>
                    <input
                      matInput
                      name="workOrderId"
                      required
                      placeholder="{{ 'orders.work.order' | translate }}"
                      [ngModel]="pkg.workOrderId"
                      readonly
                    />
                  </mat-form-field>
                  <mat-form-field style="width: 100px">
                    <mat-label>{{ 'facilities.facility' | translate }}</mat-label>
                    <input
                      matInput
                      name="facility"
                      required
                      placeholder="{{ 'facilities.facility' | translate }}"
                      [ngModel]="pkg.facility"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field>
                    <mat-label>{{ 'context.type' | translate }}</mat-label>
                    <elder-select
                      appPackageTypeSelect
                      name="type"
                      class="flex"
                      readonly
                      placeholder="{{ 'context.type' | translate }}"
                      valueAsId
                      [(value)]="pkg.typeId"
                    >
                    </elder-select>
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field>
                    <mat-label>{{ 'context.state' | translate }}</mat-label>
                    <elder-select
                      appPackageStateSelect
                      name="state"
                      placeholder="{{ 'context.state' | translate }}"
                      readonly
                      valueAsId
                      [(value)]="pkg.state"
                    >
                    </elder-select>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>{{ 'packages.dispatchState.title' | translate }}</mat-label>
                    <input
                      matInput
                      name="dispatchState"
                      readonly
                      placeholder="{{ 'packages.dispatchState.title' | translate }}"
                      [ngModel]="'packages.dispatchState.' + pkg.dispatchState.state | translate"
                    />
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field>
                    <mat-label>{{ 'context.description' | translate }}</mat-label>
                    <input
                      matInput
                      name="description"
                      placeholder="{{ 'context.description' | translate }}"
                      [(ngModel)]="pkg.description"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="layout-row">
              <!-- Characteristics -->
              <div class="flex layout-col">
                <elder-pane-subtitle>{{
                  'context.characteristics' | translate
                }}</elder-pane-subtitle>
                <div class="layout-row gap-md">
                  <mat-form-field floatLabel="always">
                    <mat-label>{{ 'context.weight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="weight"
                      readonly
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.weight"
                    >
                    </elder-quantity-input>
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                  <mat-form-field floatLabel="always">
                    <mat-label>{{ 'packages.maxWeight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="maxWeight"
                      placeholder="-"
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.spec.maxWeight"
                    >
                    </elder-quantity-input>
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field floatLabel="always">
                    <mat-label>{{ 'context.contentWeight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="contentWeight"
                      readonly
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.contentWeight"
                    >
                    </elder-quantity-input>
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                  <mat-form-field floatLabel="always">
                    <mat-label>{{ 'context.packagingWeight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="packagingMaterialWeight"
                      readonly
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.packagingMaterialWeight"
                    >
                    </elder-quantity-input>
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field>
                    <mat-label>{{ 'context.dimension' | translate }}</mat-label>
                    <elder-dimensions-input
                      [name]="'dimensions'"
                      [(ngModel)]="pkg.dimensions"
                      [placeholderLength]="'dimensions.length' | translate"
                      [placeholderWidth]="'dimensions.width' | translate"
                      [placeholderHeight]="'dimensions.height' | translate"
                      [unit]="pkg.type.dimensionUnit"
                    >
                    </elder-dimensions-input>
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Misc -->
            <div class="layout-col">
              <elder-pane-subtitle>{{ 'Weiteres' | translate }}</elder-pane-subtitle>
              <elder-audited-entity [audited]="package.audit"> </elder-audited-entity>
            </div>
          </elder-pane-content>
        </elder-pane>
        <!-- Tabbed pane -->
        <elder-pane>
          <elder-pane-content>
            <mat-tab-group class="flex">
              <!-- Packaging Goods -->
              <mat-tab class="flex" label="{{ 'packages.packagingGoods' | translate }}">
                <app-packaging-goods [pkg]="pkg"></app-packaging-goods>
              </mat-tab>
              <!-- Storage -->
              <mat-tab label="{{ 'shopfloor.storage.storage' | translate }}">
                <div class="p-sm">
                  <app-package-storage-location [pkg]="pkg"></app-package-storage-location>
                </div>
              </mat-tab>
              <!-- Packaging -->
              <mat-tab label="{{ 'packages.packaging' | translate }}">
                <app-packaging-material-table
                  class="flex"
                  [packagingItems]="pkg.packagingItems"
                  [packagingMaterialSpecs]="pkg.type.supportedPackagingMaterials"
                  (packagingItemsChange)="onPackagingItemsChange($event)"
                >
                </app-packaging-material-table>
              </mat-tab>
            </mat-tab-group>
          </elder-pane-content>
        </elder-pane>
      </elder-basic-pane-layout>
    </form>
  </div>
}
